<template>
  <div class="panel-body">
    <div class="">
      <div>
        <fieldset class="border select-plan">
          <legend class="border">出金方式</legend>
          <div class="select-plan m-t">
            <div class="radio">
              <div class="row plan">
                <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                  <input type="radio"
                    id="autoPayment"
                    v-model="autoPayment"
                    value=true
                    @change="handleChangeAutoPayment"
                  >
                  <label for="'autoPayment">自動出金方式</label>
                </div>
                <div class="col-sm-9 plan-block pd-t-15 pd-b-15">
                  <p>報酬額が10000円以上であれば、自動的に出金処理が行われます。</p>
                  <p>振込のタイミングは、下記で指定した出金サイクルとなります。</p>
                  <p>
                    <input
                      type="checkbox" id="forcePayment" v-model="forcePayment">
                    <span>10,000円未満の場合でも出金処理をする ※10,000円未満出金手数料330円(税込)</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="radio">
              <div class="row plan">
                <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                  <input
                    type="radio"
                    id="carrOver"
                    v-model="autoPayment"
                    value=false
                    @change="handleChangeAutoPayment"
                  >
                  <label for="'carrOver">キャリーオーバー方式</label>
                </div>
                <div class="col-sm-9 plan-block pd-t-15 pd-b-15">
                  <p>振込が繰り越されます。</p>
                  <p>次回の締め日に出金処理を行う場合は「自動出金方式」へ変更してください。</p>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div v-if="autoPayment" class="mr-t-10">
        <fieldset class="border">
          <legend class="border">今月の出金サイクル（変更できません）</legend>
            <div v-if="currentCycle" class="row current plan">
              <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                <span v-html="replaceHTMLSellerInfo(currentCycle.payment_cycle_name)"></span>
              </div>
              <div class="col-sm-9 plan-block pd-t-15 pd-b-15">
                <span v-html="replaceHTMLSellerInfo(currentCycle.description)"></span>
              </div>
            </div>
        </fieldset>
      </div>
      <div v-if="autoPayment" class="mr-t-10">
        <fieldset class="border select-plan">
          <legend class="border">来月からの出金サイクル</legend>
          <p class="description">変更する場合は、選択してください。</p>
          <div class="select-plan m-t">
            <div class="radio" v-for="(cycle, index) in cycleList" :key="index">
              <div class="row plan">
                <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                  <input type="radio" :value="cycle" :id="'cycle' + index" v-model="cycleSelected">
                  <label :for="'cycle' + index" v-html="replaceHTMLSellerInfo(cycle.payment_cycle_name)"></label>
                </div>
                <div class="col-sm-9 plan-block pd-t-15 pd-b-15">
                  <span v-html="replaceHTMLSellerInfo(cycle.description)"></span>
                </div>
              </div>
            </div>
            <div class="row mr-t-30">
              <div class="col-sm-12">
                <!-- TODO こちらのlink先を設定 -->
                <p>※出金サイクルについての詳細は<a :href="downloadUrl" target="_blank">こちら</a></p>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mr-t-10 update-btn">
        <button class="btn btn-info w-200" :disabled="!cycleSelected" @click.prevent="handleSubmit">更新</button>
      </div>
    </div>
  </div>
</template>

<script>
import Const from '@/common/msg'
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      cycleSelected: null,
      cycleList: [],
      currentCycle: null,
      autoPayment: null,
      forcePayment: null,
      error: null,
      loader: null,
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/payment-cycle.pdf`,
      cyclePaymentDefault: {
        next_payment_cycle_code: '',
        auto_payment: '',
        force_payment: ''
      }
    }
  },
  async created () {
    await this.getCurrentCycle()
    if (this.$route.params.tab === 'payment-cycle') {
      this.$events.fire('done')
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    async getCurrentCycle () {
      var self = this
      this.loader = this.$loading.show()
      SettingService.getPaymentCycle()
        .then((response) => {
          self.currentCycle = response.cycles.find(cycle => cycle.payment_cycle_code === response.now_cycle.payment_cycle_code)
          self.cycleList = response.cycles
          self.autoPayment = response.auto_payment
          self.forcePayment = response.force_payment
          self.cycleSelected = response.cycles.find(cycle => cycle.payment_cycle_code === response.next_cycle.payment_cycle_code)

          this.cyclePaymentDefault.next_payment_cycle_code = response.next_cycle.payment_cycle_code
          this.cyclePaymentDefault.auto_payment = response.auto_payment
          this.cyclePaymentDefault.force_payment = response.force_payment
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },

    async handleSubmit () {
      let self = this
      this.loader = this.$loading.show()
      const payload = {
        next_payment_cycle_code: this.cycleSelected.payment_cycle_code,
        auto_payment: this.autoPayment,
        force_payment: this.forcePayment
      }
      let logParams = {
        name: eventCode.settings.payment_cycle_tab.click_update_button,
        properties: {
          oldPaymentCycleInfo: self.cyclePaymentDefault,
          newPaymentCycleInfo: payload
        }
      }
      EventService.postTrackLog(logParams)

      SettingService.updatePaymentCycle(payload)
        .then((response) => {
          this.cyclePaymentDefault = payload
          this.$store.commit('toggleModal', {
            show: true,
            message: Const.updateSuccess
          })
        })
        .catch((err) => {
          self.$store.commit('toggleModal', {
            show: true,
            message: Const.updateFail
          })
          self.error = err
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },

    handleChangeAutoPayment (e) {
      this.autoPayment = event.target.value === 'true'
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'payment-cycle') {
      let logParams = {
        name: eventCode.settings.payment_cycle_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.current {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/PayCycle.vue